// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QFLJ","fullView":"styles_fullView__1R6PZ"};